var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mainClass},[_vm._l((5),function(i){return _c('i',{key:i,class:{ 
                'fa': i <= _vm.reviewInfos.rating, 
                'far': i > _vm.reviewInfos.rating, 
                'fa-star': true 
              }})}),_vm._v(" "),_c('span',{class:_vm.ratingClass},[_c('a',{attrs:{"href":"#reviews"}},[_vm._v("( "+_vm._s(_vm.reviewInfos.reviews_number)+" 件 )")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }